const today = new Date('2021-01-01');
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
const nextYear = new Date(today.getFullYear() + 1, 11, 31);
export const defaultConfig = {
    adults: {
        min: 1,
        max: 52,
        defaultValue: 2,
    },
    children: {
        min: 0,
        max: 10,
        defaultValue: 0,
    },
    infants: {
        min: 0,
        max: 10,
        defaultValue: 0,
    },
    pets: {
        min: 0,
        max: 3,
        defaultValue: 0,
    },
    dates: {
        min: tomorrow,
        max: nextYear,
        defaultValue: '',
    },
    destination: {
        defaultValue: '',
    },
    destinationURL: {
        defaultValue: '/all-regions',
    },
    destinationId: {
        defaultValue: '',
    },
    flexibility: {
        options: [
            {
                label: '',
                options: [
                    { value: '3', text: '+/- 3 days' },
                    { value: '7', text: '+/- 7 days' },
                    { value: '1', text: 'Exact Date' },
                ],
            },
        ],
        defaultValue: '3',
    },
    duration: {
        options: [
            {
                label: 'Popular Durations',
                options: [
                    { value: '3', text: '3 nights' },
                    { value: '4', text: '4 nights' },
                    { value: '7', text: '7 nights' },
                    { value: '2', text: '2 nights' },
                ],
            },
            {
                label: 'Other Durations',
                options: [
                    { value: '1', text: '1 night' },
                    { value: '5', text: '5 nights' },
                    { value: '6', text: '6 nights' },
                    { value: '10', text: '10 nights' },
                    { value: '14', text: '14 nights' },
                    { value: '21', text: '21 nights' },
                    { value: '28', text: '28 nights' },
                ],
            },
        ],
        defaultValue: '7',
    },
    accommodationType: {
        options: [
            {
                label: 'Property Type',
                options: [
                    { value: 'holiday-parks', text: 'Holiday Parks' },
                    { value: 'lodges', text: 'Lodges' },
                    { value: 'cottages', text: 'Cottages' },
                    {
                        value: 'boat-holidays',
                        text: 'Boat Holidays',
                        destinationListParentID: 'boats',
                        rhsHeaders: {
                            rhs1: 'Choose boats region',
                            rhs2: 'Choose boats area',
                        },
                    },
                ],
            },
        ],
        defaultValue: 'lodges',
    },
    destinationListConfig: {
        destinationFetch: () => Promise.resolve(undefined),
    },
    showAccommodationField: true,
    showDestinationField: true,
    showDurationInput: true,
};
export const defaultTranslation = {
    searchBar: {
        searchFormSubmitBtn: 'Search',
    },
    destination: {
        searchFormTitle: 'Your search',
        inputTitle: 'Search destination',
        accordionTitle: 'Select destination',
        iconLabel: 'Destination picker',
        placeholder: 'Enter destination',
        popularAreas: 'Popular Areas',
        popularAreasExpand: 'All Popular Areas',
        popularDestinations: 'Popular Destinations',
        closeBtn: 'Close',
        clearBtn: 'Clear',
        drawerPlaceholder: 'Browse by country or region',
        drawerLabel: 'Destination',
        autocomplete: {
            firstGroupHeading: 'Destinations',
            secondGroupHeading: 'Holiday Homes',
            placeholder: 'eg. Cumbria or Dorset',
            error: 'There was an error.',
            loading: 'Loading...',
            noResult: 'We don’t have %s in our destinations list. Try a different search or go back to our destination list.',
            noResultBtn: 'Browse destinations',
            clearButtonAriaLabel: 'Clear the search field',
        },
        allOfPrefix: 'All of',
        rhsHeaders: {
            rhs1: 'Choose country',
            rhs2: 'Choose region',
            rhs3: 'Choose area',
            rhs4: '',
        },
        backBtn: 'Back',
        inputFacadeClearButtonAriaLabel: 'clear fields',
        nearby: {
            ctaTitle: 'Properties Nearby',
            ctaDescription: 'Find properties within 80 miles of you. We’ll need your browser location.',
            destinationField: 'Properties Nearby',
            geolocationPermissionWarning: 'You must allow your browser location request to view nearby properties.',
        },
    },
    datesSelector: {
        placeholder: 'Enter dates',
        confirm: 'Apply',
        startDateLabel: 'Start date',
        startDateInfoText: 'Get exact prices and availability',
        startDatePlaceholder: 'Select',
        startDateAriaLabel: 'Date picker input',
        durationLabel: 'Duration',
        durationValidationMsg: 'Please select how much flexibilty in dates you wish to have',
        rangeLabel: 'Flexibility',
        rangeValidationMsg: 'Please choose the duration of your stay',
        calendarFormTitle: 'Check In and Duration',
        clearBtn: 'Clear',
        closeBtn: 'Close drawer',
        decline: 'decline',
        calendarTranslations: {
            prevButtonTitle: 'View previous month',
            nextButtonTitle: 'View next month',
            unavailabilityHeadingText: "There aren't any available dates",
            unavailabilityMessageText: "We couldn't find any available dates for your trip duration.\n" +
                '              Please change the duration and try again.',
            formatPrice: (price) => `£${price}`,
        },
        inputFacadeClearButtonAriaLabel: 'clear fields',
        nightLabel: 'night',
        nightsLabel: 'nights',
    },
    partySelector: {
        partySizeInput: {
            iconLabel: 'Party size',
            placeholder: 'Enter Party',
        },
        drawer: {
            heading: 'Guests',
            closeLabel: 'Close',
            buttonLabel: 'Apply',
        },
        infants: {
            validationMsg: 'Please choose how many infants are going',
            label: 'Infants',
            description: 'Aged up to 2',
        },
        children: {
            validationMsg: 'Please choose how many children are going',
            label: 'Children',
            description: 'Aged 2-17',
        },
        adults: {
            validationMsg: 'Please choose how many adults are going',
            label: 'Adults',
            description: 'Aged 18+',
        },
        pets: {
            validationMsg: 'Please choose how many pets are going',
            label: 'Pets',
        },
        summary: {
            guest: 'guest',
            guestPlural: 'guests',
            pet: 'pet',
            petPlural: 'pets',
        },
        inputFacadeClearButtonAriaLabel: 'clear fields',
    },
    summaryStrings: {
        hintLabel: 'Where would you like to go?',
        defaultPlaceholder: 'Add destination, dates, guests',
        dateNoLocationPlaceholder: 'Add destination',
        locationNoDatePlaceholder: 'Add date for exact prices and availability',
        daysLabel: 'days',
        nightLabel: 'night',
        nightsLabel: 'nights',
        guestLabel: 'guest',
        guestsLabel: 'guests',
        searchIconTitle: 'Open search panel',
    },
    accommodationSelector: {
        placeholder: 'Accommodation type',
        inputFacadeClearButtonAriaLabel: 'clear fields',
    },
};
export const initialValues = {
    destination: 'England',
    destinationURL: '/england',
    start: new Date('2021-01-01'),
    nights: 7,
    range: 3,
    adult: 4,
    child: 3,
    infant: 2,
    pets: 1,
};
export const novaTranslationsDA = (defaultTranslation) => {
    return {
        searchBar: {
            searchFormSubmitBtn: 'Søg',
        },
        destination: {
            ...defaultTranslation.destination,
            inputTitle: 'Søg efter destinationer',
            searchFormTitle: 'Find rejse',
            placeholder: 'Vælg destination',
            closeBtn: 'Luk',
            clearBtn: 'Nulstil',
            autocomplete: {
                ...defaultTranslation.destination.autocomplete,
                firstGroupHeading: 'Destinationer',
                secondGroupHeading: 'Feriehuse',
                loading: 'Henter...',
                placeholder: 'Hvor vil du rejse hen?',
                noResult: 'Vi fandt ingen resultater for %s. Indtast ny søgning, eller gå tilbage til destinations listen.',
                noResultBtn: 'Gennemse rejsemål...',
            },
            rhsHeaders: {
                rhs1: 'Vælg land',
                rhs2: 'Vælg region',
                rhs3: 'Vælg område',
                rhs4: '',
            },
            backBtn: 'Tilbage',
        },
        datesSelector: {
            ...defaultTranslation.datesSelector,
            placeholder: 'Vælg afrejse dato',
            durationLabel: 'Varighed',
            rangeLabel: 'Jeg er fleksibel',
            calendarFormTitle: 'Ankomst og varighed',
            closeBtn: 'Luk',
            clearBtn: 'Nulstil',
            nightLabel: 'nat',
            nightsLabel: 'nætter',
        },
        partySelector: {
            ...defaultTranslation.partySelector,
            partySizeInput: {
                iconLabel: 'Antal gæster',
                placeholder: 'Vælg gæster',
            },
            drawer: {
                heading: 'Gæster',
                closeLabel: 'Luk',
                buttonLabel: 'Vælg',
            },
            children: {
                validationMsg: 'Vælg antal børn',
                label: 'Børn',
                description: '0-11 år',
            },
            adults: {
                validationMsg: 'Vælg antal voksne',
                label: 'Antal voksne',
                description: '',
            },
            pets: {
                validationMsg: 'Vælg antal husdyr',
                label: 'Husdyr',
            },
            summary: {
                guest: 'gæst',
                guestPlural: 'gæster',
                pet: 'husdyr',
                petPlural: 'husdyr',
            },
            inputFacadeClearButtonAriaLabel: 'slet valg',
        },
        summaryStrings: {
            hintLabel: 'Hvor vil I rejse hen?',
            defaultPlaceholder: 'Tilføj rejsemål, ankomstdato, antal gæster',
            dateNoLocationPlaceholder: 'Vælg rejsemål',
            locationNoDatePlaceholder: 'Tilføj dato for specifike priser og tilgængelighed',
            daysLabel: 'dage',
            nightLabel: 'nat',
            nightsLabel: 'nætter',
            guestLabel: 'gæst',
            guestsLabel: 'gæster',
            searchIconTitle: 'Gå til søgning',
        },
    };
};
export const novaDefaultConfig = {
    infants: {
        min: 0,
        max: 0,
        defaultValue: 0,
    },
    flexibility: {
        options: [
            {
                label: '',
                options: [
                    { value: '3', text: '+/- 3 dage' },
                    // { value: '7', text: '+/- 7 dage' },
                    { value: '1', text: 'Specifik dato' },
                ],
            },
        ],
        defaultValue: '3',
    },
    duration: {
        options: [
            {
                label: 'Populære perioder',
                options: [
                    { value: '3', text: '3 dage' },
                    { value: '4', text: '4 dage' },
                    { value: '7', text: '7 dage' },
                    { value: '2', text: '2 dage' },
                ],
            },
            {
                label: 'Alternative perioder',
                options: [
                    { value: '1', text: '1 dage' },
                    { value: '5', text: '5 dage' },
                    { value: '6', text: '6 dage' },
                    { value: '10', text: '10 dage' },
                    { value: '14', text: '14 dage' },
                    { value: '21', text: '21 dage' },
                    { value: '28', text: '28 dage' },
                ],
            },
        ],
        defaultValue: '7',
    },
};
//# sourceMappingURL=search-form.example-config.js.map